// MATERIAL UI
import { Stack } from "@mui/material";

// COMPONENTS
import {
  StyledCancelledText,
  StyledContentHightLight,
  StyledLabel,
  StyledTitle,
} from "./styled-components/TableStyledComponents";

// UTILS
import { dynamicPriceFormatter, formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import { dateFormatter } from "src/utils/helpers/DateAndTimeHelpers";

// REDUX
import { DcaStrategyDto } from "src/store/features/api/generated";

export default function YourPlan({ strategy }: { strategy: DcaStrategyDto }) {
  const {
    sellCurrency: { code: sellToken },
    buyCurrency: { code: buyToken },
    status,
    averagePurchasePrice,
    spendLimit,
    nextOrderDueDate,
    endDate,
    accumulatedBalance,
    strategyValue,
  } = strategy;

  const nextOrderStatus = (status: string): string => {
    if (status === "Completed") return "Strategy Completed";
    if (status === "Cancelled") return "Strategy Cancelled";
    return "Next scheduled";
  };

  const formatNextOrderDueDate = (status: string, nextOrderDueDate: number): string | number => {
    if (status === "Completed" || status === "Cancelled") return "-";
    return dateFormatter(nextOrderDueDate);
  };

  return (
    <>
      {" "}
      <StyledContentHightLight>
        <StyledLabel>Accumulated balance</StyledLabel>
        <StyledTitle sx={{ fontSize: "16px" }}>
          {`${accumulatedBalance ? accumulatedBalance : "0.00"} ` + buyToken}
        </StyledTitle>
        <StyledLabel> {formatCurrency(strategyValue, sellToken)}</StyledLabel>
        {status === "Cancelled" && <StyledCancelledText>Cancelled</StyledCancelledText>}
        {[
          {
            label: "Average Purchase Price",
            value: dynamicPriceFormatter(averagePurchasePrice, sellToken) ?? "-",
          },
          { label: "Spend limit", value: spendLimit ?? "-" },
          { label: "End date", value: endDate ? dateFormatter(endDate) : "-" },
        ].map(({ label, value }) => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <StyledLabel>{label}</StyledLabel>
            <StyledLabel>{value}</StyledLabel>
          </div>
        ))}
      </StyledContentHightLight>
      <Stack direction="row" justifyContent={"space-between"} my={2}>
        <StyledLabel>{nextOrderStatus(status)}</StyledLabel>
        <StyledLabel>{formatNextOrderDueDate(status, nextOrderDueDate)}</StyledLabel>
      </Stack>
    </>
  );
}
